// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"j1-z","displaySixCardTiles":"k1-z"};